export const Services = {
   "ADMIN": {
      "path": "https://roldanapiadmin.azurewebsites.net",
      "descrp": "API Admin"
   }
}